export default __webpack_public_path__ + "static/img-ogp-2921b5b107eaaecf323473d4cc242948.png";